module.exports = __webpack_public_path__ + "img/bed.12af3f89.png";